import { gql } from "@apollo/client"

const ALL_DEPARTMENTS = gql`
  query AllDepartmentSelector {
    allDepartments {
      id
      name
      departmentType
    }
  }
`

const GROUPS = gql`
  query allGroupsSelector($category: String, $filter: AllGroupsFilterInput) {
    allGroups(category: $category, filter: $filter) {
      id
      name
      category {
        id
        name
        codename
      }
    }
  }
`

const VARIETY_GROUPS = gql`
  query allVarietyGroupsSelector(
    $departmentId: Int
    $query: String
    $first: Int
  ) {
    allVarietyGroups(
      departmentId: $departmentId
      query: $query
      first: $first
    ) {
      id
      name
      codename
    }
  }
`
const PERMISSIONS = gql`
  query allPermissionsSelector {
    allPermissions {
      id
      name
    }
  }
`

const VARIETIES = gql`
  query allVarietiesSelector($includeCommodity: Boolean!) {
    allVarieties {
      id
      name
      commodity @include(if: $includeCommodity) {
        id
        name
      }
    }
  }
`

const COMMODITIES = gql`
  query allCommoditiesSelector {
    allCommodities {
      id
      name
    }
  }
`
const COMPANIES = gql`
  query allCompaniesSelector($id: Int) {
    allCompanies(departmentId: $id) {
      id
      kind
      name
      displayName
      codename
    }
  }
`
const HARVEST_GRADES = gql`
  query allHarvestGradesSelector($id: Int) {
    harvestGradesForVariety(variety: $id) {
      id
      name
      specifications
    }
  }
`

const SKUS = gql`
  query allSkusSelector($filter: SKUTypeFilterInput) {
    allSkuTypes(filter: $filter) {
      id
      name
      capacity
      selfWeight
      capacityUnit {
        id
        name
        codename
      }
    }
  }
`

const SOIL_TYPES = gql`
  query allSoilTypesSelector {
    allSoilTypes {
      id
      name
    }
  }
`

const TIME_SLOTS = gql`
  query allTimeSlotsSelector {
    allTimeSlots {
      id
      fromTime
      toTime
      name
    }
  }
`

const SI_UNITS = gql`
  query allSiUnitsSelector {
    allSiUnits {
      id
      name
      codename
    }
  }
`

const CERTIFICATES = gql`
  query allCertificationTypesSelector {
    allCertificationTypes {
      id
      name
    }
  }
`

const DEPOTS = gql`
  query allDepotsSelector {
    allDepots {
      id
      name
    }
  }
`

const VEHICLE_TYPES = gql`
  query allVehicleTypesSelector {
    allVehicleTypes {
      id
      name
      category
    }
  }
`

const VEHICLE_KINDS = gql`
  query allVehicleKindsSelector {
    allVehicleKind {
      id
      name
    }
  }
`

const BANKS = gql`
  query allBanksSelector {
    allBanks {
      id
      codename
      name
    }
  }
`

const KYCS = gql`
  query allKycTypesSelector {
    allKycTypes {
      id
      name
    }
  }
`
const USERS = gql`
  query allUsersByGroupSelector(
    $group: String
    $first: Int
    $skip: Int
    $query: String
    $departmentId: ID
    $filter: UsersByGroupFilterInput
  ) {
    usersByGroup(
      groupName: $group
      first: $first
      skip: $skip
      query: $query
      departmentId: $departmentId
      filter: $filter
    ) {
      id
      fullName
      number
    }
  }
`

const MARKETS = gql`
  query allMarketsSelector {
    allMarkets {
      id
      name
      codename
    }
  }
`

const VEHICLES = gql`
  query allVehiclesSelector {
    allVehicles {
      id
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
    }
  }
`

const SKU_CATEGORIES = gql`
  query allSkuCategoriesSelector {
    allSkuCategories {
      id
      name
      codename
    }
  }
`

const REFERENCE_GRADES = gql`
  query allReferenceGradesSelector {
    referenceGrades {
      id
      name
      specifications
    }
  }
`

const UNLOADING_TEAMS = gql`
  query allUnloadingTeamsSelector {
    allUnloadingTeams {
      id
      name
      contact
      codename
    }
  }
`

export const EXPENSE_TYPES = gql`
  query allExpenseTypesSelector {
    allExpenseTypes {
      id
      name
      codename
    }
  }
`

export const PAYMENT_TYPES = gql`
  query allPaymentTypesSelector {
    allPaymentTypes {
      id
      name
    }
  }
`

export const FUEL_TYPES = gql`
  query allFuelTypesSelector {
    allFuelTypes {
      id
      name
      codename
    }
  }
`

export const CONTRACT_TYPES = gql`
  query allContractTypesSelector {
    allContractTypes {
      id
      name
      codename
    }
  }
`
export const MARKET_YARDS = gql`
  query allMarketYardsSelector {
    allMarketYards {
      id
      name
      address {
        id
        village
      }
    }
  }
`

export const DISTRIBUTION_CENTERS = gql`
  query allDistributionCentersSelector {
    allDistributionCentres {
      id
      name
    }
  }
`

export const DC_SURVEY_AREAS = gql`
  query dcSurveyAreas($dcId: ID) {
    allSurveyAreas(filter: { distributionCentreIds: [$dcId] }) {
      id
      properties {
        name
      }
    }
  }
`
export const ALLCPC = gql`
  query allCPCSelector {
    allDistributionCentres(filter: { isManufacturingPlant: true }) {
      id
      name
    }
  }
`

export const DC_CURRENT_STOCK_PERCENTAGE = gql`
  query DistributionCentersCurrentStock($id: ID!) {
    distributionCentreDetail(id: $id) {
      currentStockPercentage
    }
  }
`

export const SELLABLE_ITEM_GROUPS = gql`
  query allSellableItemGroupsSelector {
    allSellableItemGroups {
      id
      name
      codename
    }
  }
`

export const SELLABLE_ITEMS = gql`
  query allSellableItemSelector {
    allSellableItems {
      id
      name
    }
  }
`

export const SEARCH_SELLABLE_ITEMS = gql`
  query searchSellableItems(
    $query: String
    $first: Int
    $skip: Int
    $filter: SellableItemFilterInput
  ) {
    allSellableItems(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      name
      secondarySkuType {
        id
        capacity
      }
    }
  }
`

export const SEARCH_BATCH_STOCKS = gql`
  query searchBatchStock(
    $query: String
    $first: Int
    $skip: Int
    $filter: BatchStockFilterInput
  ) {
    allBatchStocks(query: $query, first: $first, skip: $skip, filter: $filter) {
      id
      name: codename
      currentStockCount
      suppliedBy {
        id
      }
      expiryOn
      manufacturedOn
    }
  }
`

export const REPORT_MASTERS = gql`
  query allReportMastersSelector {
    allReportMasters {
      id
      alias
    }
  }
`

export const NOTIFICATION_TEMPLATES = gql`
  query allNotificationTempletes {
    allNotificationTempletes {
      id
      name: alias
    }
  }
`

export const STATES = gql`
  query allStates {
    allStates {
      id
      name
      codename
    }
  }
`

export const PERIODIC_TASK_TYPES = gql`
  query periodicTaskTypes {
    allTasks
  }
`

export const ROUTES = gql`
  query allRoutesSelector($filter: RouteInput) {
    allRoutes(filter: $filter) {
      id
      name
      surveyArea {
        id
        properties {
          name
        }
      }
    }
  }
`

export const ROUTE_CATEGORIES = gql`
  query allRouteCategorys {
    allRouteCategorys {
      id
      name
    }
  }
`

export const ALL_PAYMENT_METHODS = gql`
  query allPaymentMethods {
    allPaymentMethods {
      id
      name
    }
  }
`

export const ALL_TRANSACTION_TYPES = gql`
  query allTransactionTypes {
    allTransactionTypes {
      id
      name
    }
  }
`

const UNLOADING_SUB_LOCATIONS = gql`
  query AllUnloadingSubLocations($query: String, $filter: ID!) {
    allUnloadingSubLocations(
      query: $query
      filter: { unloadingLocationId: $filter }
    ) {
      id
      name
      unloadingLocation {
        id
        name
      }
    }
  }
`

export const ALL_HOLDING_AREAS = gql`
  query holdingAreas {
    holdingAreas {
      id
      name
    }
  }
`

export const PRODUCTION_LINE = gql`
  query productionLines($departmentId: ID, $depotId: ID) {
    productionLines(departmentId: $departmentId, depotId: $depotId) {
      id
      name
    }
  }
`

// Production-specific selector queries
const EXPORT_CUSTOMER = gql`
  query allExportCustomersSelector {
    allExportCustomers {
      id
      name
    }
  }
`

const PORT = gql`
  query allPortsSelector {
    allPorts {
      id
      name
    }
  }
`

const COLOR_GROUP = gql`
  query allColorGroupsSelector {
    allColorGroups {
      id
      name
      codename
    }
  }
`

const PRIMARY_PACK_MATERIAL = gql`
  query allPrimaryPackMaterialsSelector {
    allPackingMaterials(typeName: "PRIMARY") {
      id
      name
      codename
    }
  }
`

const SECONDARY_PACK_MATERIAL = gql`
  query allSecondaryPackMaterialsSelector {
    allPackingMaterials(typeName: "SECONDARY") {
      id
      name
      codename
    }
  }
`

const GATE_NUMBERS = gql`
  query allGatesSelector {
    gateNumbers {
      id
      name
      codename
    }
  }
`

export {
  ALL_DEPARTMENTS,
  BANKS,
  CERTIFICATES,
  COMMODITIES,
  COMPANIES,
  DEPOTS,
  GATE_NUMBERS,
  GROUPS,
  HARVEST_GRADES,
  KYCS,
  MARKETS,
  PERMISSIONS,
  REFERENCE_GRADES,
  SI_UNITS,
  SKUS,
  SKU_CATEGORIES,
  SOIL_TYPES,
  TIME_SLOTS,
  UNLOADING_TEAMS,
  UNLOADING_SUB_LOCATIONS,
  EXPORT_CUSTOMER,
  PORT,
  COLOR_GROUP,
  PRIMARY_PACK_MATERIAL,
  SECONDARY_PACK_MATERIAL,
  USERS,
  VARIETIES,
  VARIETY_GROUPS,
  VEHICLES,
  VEHICLE_KINDS,
  VEHICLE_TYPES,
}
